export default __webpack_public_path__ + "static/media/29.e8fc911a.png";